import {
    Button,
    Dialog,
    DialogContent,
    DialogFooter,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
} from "@/components/ui";
import { APP_LOCAL_DATE_FORMAT } from "@/config/constants";
import { useAppSelector } from "@/config/store";
import { IEdoFile } from "@/shared/model/edo-file.model";
import { IEdoUnit } from "@/shared/model/edo-unit.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { getFileAvatar } from "@/shared/util/file-avatar-utils";
import { Download, Eye, Loader2 } from "lucide-react";
import axios from "axios";
import "moment/locale/it";
import { useEffect, useState } from "react";
import { TextFormat, Translate } from "react-jhipster";

export interface ViewUnitProps {
  open: boolean;
  handleClose: () => void;
  unit: IEdoUnit;
}

export const ViewUnit = (props: ViewUnitProps) => {
  const [files, setFiles] = useState<IEdoFile[]>([]);
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );

  const { open, handleClose, unit } = props;

  useEffect(() => {
    const getUnitFiles = async () => {
      const response = await axios.get(`/units/${props.unit.id}/files`);
      setFiles(response.data.data);
    };

    if (unit) {
      getUnitFiles();
    }
  }, [unit]);

  const openFile = (file: IEdoFile) => {
    window.open(`/api/files/${file.id}/view`, "_blank");
  };

  const downloadFile = (file: IEdoFile) => {
    window.open(`/api/files/${file.id}/download`, "_blank");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && handleClose()}>
      <DialogContent className="max-w-lg gap-0 p-0">
        {unit === null ? (
          <div className="flex items-center justify-center p-8">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
          </div>
        ) : (
          <>
            <div className="max-h-[60vh] overflow-y-auto p-6">
              <List className="divide-y divide-[var(--color-mockup-border)]">
                {!unit || !files?.length ? (
                  <div className="py-6 text-center text-sm text-[var(--color-mockup-text-light)]">
                    <Translate contentKey="edocendoApp.edoFile.home.notFound">
                      No Edo Files found
                    </Translate>
                  </div>
                ) : (
                  files.map((file) => (
                    <ListItem
                      key={file.id}
                      className="flex cursor-default items-center gap-3 py-3"
                    >
                      <div className="shrink-0">
                        {getFileAvatar(file.fileType)}
                      </div>
                      <ListItemText
                        className="min-w-0 flex-1 truncate"
                        primary={file.originalFileName}
                        secondary={
                          <TextFormat
                            value={file.createdAt}
                            type="date"
                            format={APP_LOCAL_DATE_FORMAT}
                          />
                        }
                      />
                      <ListItemSecondaryAction className="flex gap-1">
                        <IconButton
                          onClick={() => openFile(file)}
                          aria-label="Apri file"
                          size="sm"
                        >
                          <Eye className="h-4 w-4" />
                        </IconButton>
                        <IconButton
                          onClick={() => downloadFile(file)}
                          aria-label="Scarica file"
                          size="sm"
                        >
                          <Download className="h-4 w-4" />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))
                )}
              </List>
            </div>
            <DialogFooter className="border-t border-[var(--color-mockup-border)] px-6 py-4 dark:border-[var(--color-mockup-border)]">
              <Button variant="primary" onClick={handleClose}>
                <Translate contentKey="entity.action.cancel">Cancel</Translate>
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
